import React from 'react';

const Peace = ({width="40px", fill="#fff"}) => {
    return (
      <svg width={width} viewBox="0 0 511 511">
        <g>
          <path
            fill="none"
            className="st0"
            d="M150.6,257.3c-3.4-11.8-14.4-20-26.6-20c-10,0-19.5,5.7-24.3,14.4c-3.6,6.5-4.4,14-2.3,21.1l24.6,84.2
		c2.2,7.4,7.5,13.6,14.7,17c7.2,3.5,15.4,3.8,22.5,0.9c13-5.3,20.1-20,16.1-33.4h0C175,340.8,172.8,333.3,150.6,257.3z"
          />
          <path
            fill="none"
            className="st0"
            d="M211.1,483l69.5,0c37.9,0,71.7-25.4,82.2-61.8l0,0c1.7-6,3.4-12.1,4.8-18.5c-13.9,4.9-29.6,3.5-42.3-4.1l0-0.1
		c-1.5-0.8-4.3-2.5-10.6-6.2l-53.8-31.9c-6.2,7.1-14.5,12.5-23.7,15.2c-7.7,2.2-15.8,2.6-23.6,1.1c-6.8-1.3-13.3-4.1-19-8.1
		c-5.8,13.8-17.8,24.6-32.2,28.8c-12.9,3.8-27,2-38.6-4.5c0.8,7.4,1.9,14.5,3.2,21.3C135,454.1,170.3,483,211.1,483z"
          />
          <path
            fill="none"
            className="st0"
            d="M221.4,227.3c-5.3-7.4-14-11.7-22.9-11.7c-2.5,0-5.1,0.3-7.5,1.1c-7.1,2.1-13,6.8-16.6,13.3v0
		c-3.6,6.5-4.4,14-2.3,21.1l24.6,84.2c3.4,11.8,14.4,20,26.6,20c5.8,0,11.5-1.8,16.1-5.2c0.9-0.7,1.8-1.4,2.6-2.1
		c-8.6-7.8-14.4-18.6-16.1-30.3c-2-14.3,2.4-29.1,11.8-40l-12.3-42.3C224.5,232.6,223.2,229.8,221.4,227.3z"
          />
          <path
            fill="none"
            className="st0"
            d="M377.9,348.7c-1.8-7.2-6.3-13.2-12.7-17l-75.5-44.8c-9.4-5.6-21.8-4.9-30.9,1.8l0,0
		c-7.3,5.5-11.5,14.6-10.9,23.7l0,0.2c0,12.6,11,20.5,15.7,23.3l0,0c0,0,0,0,0,0l0.1,0c2.8,1.7,72.8,43.2,74,43.9
		c12.9,7.1,29.6,2.6,37.2-10.2C378.6,363.3,379.7,355.9,377.9,348.7z"
          />
          <path
          fill={'#fff'}
            d="M405.8,36.8L405.8,36.8c-12.1-4.1-25-3.3-36.5,2.3c-11.4,5.6-20,15.3-24.1,27.2l-58.8,158.5l-2.3-172
		c-0.2-12.7-5.3-24.7-14.4-33.6c-9.1-8.9-21.2-13.7-33.9-13.5C223,5.8,211,10.9,202.1,20c-8.9,9.1-13.7,21.2-13.5,33.9l0.5,37.1
		c0,3,1.2,5.8,3.4,7.9c2.1,2.1,4.9,3.2,8,3.2c6.2-0.1,11.1-5.2,11.1-11.3L211,53.6c-0.1-6.8,2.5-13.1,7.2-18
		c4.7-4.8,11-7.6,17.8-7.6c6.8-0.1,13.1,2.5,18,7.2c4.8,4.7,7.6,11,7.6,17.8l2.5,183.3c0.1,9.7,7.1,18,16.6,19.7
		c9.9,1.8,19.5-3.8,22.8-13.2l62.7-168.9l0.1-0.3c2.2-6.4,6.7-11.5,12.8-14.5c6.1-3,12.9-3.4,19.3-1.2c13.2,4.5,20.2,19,15.7,32.2
		l-69.8,203.2L308.6,272c-4.2-2.5-6.3-3.7-7.5-4.3l0-0.1c-10.9-6.5-24.3-8.6-36.7-5.7c-2.5,0.6-5,1.3-7.3,2.2l-10.2-34.9
		c-3.8-13-12.9-24.1-25.1-30.5c-2.9-1.5-5.9-2.7-9-3.6l-1-75.8c0-3-1.2-5.8-3.4-7.9c-2.1-2.1-4.9-3.2-8-3.2
		c-6.2,0.1-11.1,5.2-11.1,11.3l0.9,74.2c-1.9,0.3-3.8,0.8-5.7,1.3c-14.7,4.3-26.4,14.9-32.2,28.8c-8.4-5.8-18.3-9-28.5-9
		c-18,0-35.3,10.2-44,26.1c-6.4,11.7-7.9,25.3-4.2,38.2l24.1,82.6c-0.1,7.3,0.1,30.2,5.3,56.9c9.8,50.3,54.4,86.8,105.9,86.8l69.5,0
		c47.8,0,90.4-32.1,103.8-78c6.6-22.6,9.9-42,10.9-48.4c6-11.3,7.5-24.3,4.1-36.7c-3.4-12.7-11.5-23.3-22.8-30l-12.5-7.4l71.3-207.6
		C444,72.5,430.7,45.3,405.8,36.8z M159.1,375c-7.1,2.9-15.3,2.6-22.5-0.9c-7.2-3.5-12.5-9.7-14.7-17l-24.6-84.2
		c-2.1-7.1-1.3-14.6,2.3-21.1c4.8-8.8,14.4-14.4,24.3-14.4c12.2,0,23.2,8.2,26.6,20c22.2,76,24.4,83.5,24.6,84.2h0
		C179.1,355,172,369.7,159.1,375z M225.9,317.7c1.7,11.6,7.4,22.5,16.1,30.3c-0.8,0.7-1.7,1.4-2.6,2.1c-4.6,3.3-10.3,5.2-16.1,5.2
		c-12.2,0-23.2-8.2-26.6-20L172.1,251c-2.1-7.1-1.3-14.6,2.3-21.1v0c3.6-6.5,9.4-11.2,16.6-13.3c2.5-0.7,5-1.1,7.5-1.1
		c8.9,0,17.6,4.3,22.9,11.7c1.8,2.5,3.1,5.3,4,8.2l12.3,42.3C228.3,288.6,223.9,303.5,225.9,317.7z M162.6,397.5
		c14.4-4.2,26.3-15,32.2-28.8c5.7,4,12.2,6.7,19,8.1c7.8,1.5,15.9,1.2,23.6-1.1c9.2-2.7,17.5-8,23.7-15.2l53.8,31.9
		c6.2,3.7,9.1,5.4,10.6,6.2l0,0.1c12.8,7.6,28.5,9,42.3,4.1c-1.5,6.3-3.1,12.5-4.8,18.5l0,0c-10.6,36.4-44.4,61.8-82.2,61.8l-69.5,0
		c-40.9,0-76.1-28.9-83.9-68.7c-1.3-6.8-2.4-14-3.2-21.3C135.6,399.5,149.8,401.2,162.6,397.5z M337.7,379.9
		c-1.2-0.7-71.2-42.2-74-43.9l-0.1,0c0,0,0,0,0,0l0,0c-4.7-2.8-15.7-10.7-15.7-23.3l0-0.2c-0.5-9.1,3.7-18.2,10.9-23.7l0,0
		c9.1-6.6,21.5-7.3,30.9-1.8l75.5,44.8c6.4,3.8,10.9,9.8,12.7,17s0.8,14.7-3,21C367.3,382.4,350.6,387,337.7,379.9z"
          />
        </g>
      </svg>
    )
}

export default Peace;
